import { treeFilter } from 'utils/tree';
/**
 * Patches a custom select attribute so it's easier to compare.
 *
 * @param attribute The select attribute to patch.
 */
export function patchSelectAttribute(attribute) {
    var _a;
    const filteredOptions = JSON.parse(JSON.stringify(treeFilter((_a = attribute.options) !== null && _a !== void 0 ? _a : [], ({ label, value }) => !!label && !!value, 'options'), (key, value) => {
        if (key === 'options' && Array.isArray(value) && value.length === 0) {
            return;
        }
        return value;
    }));
    return Object.assign({}, attribute, {
        options: filteredOptions,
    });
}
